import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";

import { useUserContext } from "context/UserContext";
import Topbar from "components/topbar";
import InfoCard from "components/InfoCard";
import StatCard from "components/StatCard";
import MainLayout from "components/mainLayout";
import statIcon from "assets/svgs/stateIcon-1.svg";
import Notifications from "components/Notifications";
import weightIcon from "assets/svgs/weightUnits.svg";
import DashboardTable from "components/dashboardTable";
import rejectedUnits from "assets/svgs/RejectedUnits.svg";
import useGetSellerStatus from "api/queries/useGetSellerStatus";
import useGetProducts from "api/queries/useGetProducts";
import ValueCard from "components/ValueCard";
import useGetBalance from "api/queries/useGetBalance";

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useUserContext();
  const [products, setProducts] = useState([]);

  const { data, isLoading, error, refetch, isFetching } = useGetSellerStatus({
    seller_id: user?.info?._id,
  });

  console.log('Data', data);
  const sellerId = user?.info?._id;
  // console.log("🧠 Seller ID:", user?.info);

  const balanceQuery = useGetBalance(sellerId);
  // console.log("💰 Balance Query:", balanceQuery?.data?.data?.total_value_items_paid);

  const productsQuery = useGetProducts({
    page: 1,
    limit: 4,
    id: user?.info?._id,
    search: "",
    sort: "",
  });

  useEffect(() => {
    if (productsQuery.data?.products) {
      setProducts(productsQuery?.data?.products);
    }
  }, [productsQuery?.data?.products]);

  // console.log('Dashboard data', productsQuery?.data?.total_value_items_accepted);
  const value_items_remaining =  productsQuery?.data?.total_value_items_accepted -  productsQuery?.data?.total_value_items_sold;
  const totalPaymentBalance = balanceQuery?.data?.data
  ?.filter(item => item.transaction_id.transaction_type_id.name === "payment")
  .reduce((sum, item) => sum + item.transaction_id.transaction_type_id.balance, 0);

// console.log('balanceQuery', balanceQuery?.data?.data);
// assume data is your array
const paymentCount = balanceQuery?.data?.data?.filter(
  item =>
    item?.transaction_id?.transaction_type_id?.name === "payment"
).length;

// console.log("Total payment transactions:", paymentCount);

 
  return (
    <MainLayout>
      <Box>
        <Topbar title={"Dashboard"} />
        <Flex
          flex={1}
          direction={"column"}
          h={"100%"}
          w={"100%"}
          bg={"#f8fbff"}
          p={10}
          gridRowGap={6}
          position={"relative"}
        >
          <Text
            fontSize={"32px"}
            fontWeight={"500"}
            fontFamily={"PlusJakartaSansMedium"}
          >
            Hi, {user?.info?.first_name}
          </Text>
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={2}>
            <ValueCard imgSrc={statIcon} title="Value Items Accepted" amount={productsQuery?.data?.total_value_items_accepted ? productsQuery?.data?.total_value_items_accepted : 0} />
            <ValueCard
              imgSrc={weightIcon}
              title="Value Items Sold"
              amount={productsQuery?.data?.total_value_items_sold ? productsQuery?.data?.total_value_items_sold : 0}
            />
            <ValueCard
              imgSrc={rejectedUnits}
              title="Value Items Paid"
              amount={totalPaymentBalance || 0}
            />
            <ValueCard
              imgSrc={weightIcon}
              title="Value Items Remaining"
              amount={value_items_remaining || 0}
            />
          </SimpleGrid>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
            <InfoCard
              title="Total Products Accepted"
              value={data?.total_accepted ? data?.total_accepted : 0}
              // description="Total products accepted this month is 5% more than last month of December"
              buttonText="View All"
              bgColor="#ECE8FF"
              onClick={() => navigate("/products")}
            />
            <InfoCard
              title="Total Products Sold"
              value={data?.total_sold ? data?.total_sold : 0}
              // description="Total products sold this month is 5% more than last month of December"
              buttonText="View All"
              bgColor="#FDE9E9"
              onClick={() => navigate("/products")}
            />
            <InfoCard
              title="Total Payment Made"
              value={paymentCount}
              // description="Total payment made this month is 5% more than last month of December"
              buttonText="View All"
              bgColor="#E6FAF5"
              onClick={() => navigate("/my-balance")}
            />
          </SimpleGrid>
          <Flex gap="3" direction={{ base: "column", md: "row" }} w="full">
            {/* Table Section */}
            <DashboardTable products={products} />
            {/* Notifications Section */}
            {/* <Box flex="1" minW="450px">
              <Notifications />
            </Box> */}
          </Flex>
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={2}>
            {/* <StatCard imgSrc={statIcon} title="Payment Pending" amount="0" />
            <StatCard
              imgSrc={weightIcon}
              title="Waiting for Approval"
              amount={data?.waiting_approval ? data?.waiting_approval : 0}
            /> */}
            <StatCard
              imgSrc={rejectedUnits}
              title="Products Rejected"
              amount={data?.total_rejected ? data?.total_rejected : 0}
            />
            <StatCard
              imgSrc={weightIcon}
              title="Products Returned"
              amount={data?.total_returned ? data?.total_returned : 0}
            />
          </SimpleGrid>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export default Dashboard;
